import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Invalidate the public dashboard link queries for workplace requests.
 * Use after creating, updating or revoking a link so the link list refetches.
 */
export const useInvalidateWorkplaceRequestPublicDashboards = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ["workplaceRequestPublicDashboards"]
    });
  }, [queryClient]);
};
